
import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./App.css";
import Sidebar from "./components/sidebar/Sidebar";
import Topbar from "./components/topbar/Topbar";
import AdminLogin from "./pages/adminLogin/adminLogin";
import ProtectedRoute from "./pages/adminLogin/protectedRoute";
import Home from "./pages/home/Home";
import NewProduct from "./pages/newProduct/NewProduct";
import NewUser from "./pages/newUser/NewUser";
import Product from "./pages/product/Product";
import ProductList from "./pages/productList/ProductList";
import AdminDashboard from "./pages/RequestPage/request";
import ServiceList from "./pages/services/ServiceList";
import User from "./pages/user/User";
import UserList from "./pages/userList/UserList";

const App = () => {
  return (
    <BrowserRouter>
      <Routes>
        {/* LOGIN PAGE */}
        <Route path="/admin-login" element={<AdminLogin />} />

        {/* PROTECTED ADMIN PANEL */}
        <Route
          path="/*"
          element={
            <ProtectedRoute>
              <Topbar />
              <div className="container">
                <Sidebar />
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/users" element={<UserList />} />
                  <Route path="/user/:userId" element={<User />} />
                  <Route path="/newUser" element={<NewUser />} />
                  <Route path="/products" element={<ProductList />} />
                  <Route path="/services" element={<ServiceList />} />
                  <Route path="/product/:productId" element={<Product />} />
                  <Route path="/newProduct" element={<NewProduct />} />
                  <Route path="/RequestPage" element={<AdminDashboard />} />
                </Routes>
              </div>
            </ProtectedRoute>
          }
        />
      </Routes>
    </BrowserRouter>
  );
};

export default App;